var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerilog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.2 107.5",
    style: {
      enableBackground: "new 0 0 503.2 107.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.750371, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-81.9-253.4h-10l-22.9-57.3h10.4l17.7,46.6l17.9-46.6h10.1L-81.9-253.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(267.409338, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-161-302.1h-31.3v15.5h28v8.7h-28v15.8h32.3v8.7H-202v-57.3h41V-302.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(412.757872, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-255.6-253.4l-10.5-17.4c-0.5,0.1-1.4,0.1-2.6,0.1h-13.6v17.3h-9.7v-57.3h23.3c7.3,0,13,1.7,17,5.1 c4,3.4,6.1,8.2,6.1,14.5c0,4.6-1,8.5-3.1,11.6c-2,3.2-5,5.5-8.8,7l12.9,19.2H-255.6z M-282.3-279.4h13.6 c9.3,0,13.9-3.9,13.9-11.6c0-7.4-4.6-11.1-13.9-11.1h-13.6V-279.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(572.512266, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-381.2-253.4h-9.7v-57.3h9.7V-253.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(641.746371, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-424-262.2h24.8v8.8h-34.5v-57.3h9.7V-262.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(760.863411, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-503.4-302.7c5.8-5.5,13.1-8.3,21.6-8.3c8.6,0,15.8,2.8,21.6,8.3c5.8,5.5,8.8,12.4,8.8,20.6c0,8.2-2.9,15.1-8.8,20.7 c-5.8,5.6-13.1,8.4-21.6,8.4c-8.6,0-15.8-2.8-21.6-8.4c-5.8-5.6-8.8-12.5-8.8-20.7C-512.2-290.3-509.3-297.1-503.4-302.7z  M-481.7-302.3c-5.7,0-10.5,2-14.6,5.9c-4,3.9-6.1,8.7-6.1,14.4c0,5.7,2,10.5,6.1,14.5c4.1,4,8.9,5.9,14.5,5.9 c5.6,0,10.4-2,14.4-5.9c4-4,6-8.8,6-14.5c0-5.7-2-10.5-6-14.4C-471.3-300.4-476.1-302.3-481.7-302.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(939.323864, 334.800103)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-578.7-281.6h8.4v21.1c-2.9,2.2-6.4,4-10.4,5.4c-4,1.4-8,2-11.8,2c-8.5,0-15.6-2.8-21.4-8.4 c-5.8-5.6-8.7-12.5-8.7-20.7c0-8.2,2.9-15.1,8.8-20.6c5.9-5.5,13.2-8.3,21.9-8.3c4,0,8,0.7,11.9,2.2c3.9,1.4,7.3,3.4,10.1,5.9 l-5.5,7.1c-4.7-4.4-10.2-6.6-16.5-6.6c-5.8,0-10.8,2-14.8,5.9c-4,3.9-6.1,8.7-6.1,14.4c0,5.7,2,10.6,6.1,14.5 c4.1,3.9,9,5.9,14.9,5.9c4.4,0,8.8-1.3,13.2-3.9V-281.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.4,0c29.7,0,53.8,24.1,53.8,53.8c0,29.7-24.1,53.8-53.8,53.8c-29.7,0-53.8-24.1-53.8-53.8 C395.6,24.1,419.7,0,449.4,0z M433,32.2h-6.6l17.8,46.8h6.6L433,32.2z M454,75.6l-3.3-8.7l13.1-34.7h6.6L454,75.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerilog);
export default __webpack_public_path__ + "static/media/Verilog.855fa881b4331397cd5349df767c20bb.svg";
export { ForwardRef as ReactComponent };